import { IsNumberString, IsOptional } from "class-validator";
import { AnimationDto } from "./animation.dto";

export class TimingConfigDto {
	@IsOptional()
	startOffset?: string;

	@IsOptional()
	endOffset?: string;

	@IsOptional()
	duration?: string;

	@IsOptional()
	in?: AnimationDto;

	@IsOptional()
	out?: AnimationDto;
}
